import React from 'react';
import { Tooltip } from 'antd';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonBaggage({ style = {}, className = '' }) {
  const { trans } = useTranslation();
  return (
    <div className={`wagon-feature ${className}`} style={style}>
      <Tooltip title={trans('wardrobe')}>
        <img src="/wagon-icons/baggage.png" width={46} height={46} className="object-center" alt="baggage" />
      </Tooltip>
    </div>
  );
}

export default WagonBaggage;
